import React from "react";
import { useIntl } from "react-intl";
import { MdDownload } from "react-icons/md";
import "./styles.scss";

const ExportButton = ({ textId, onClick, isLoading, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <button
      className={`button ${isLoading ? " is-loading" : ""}`}
      onClick={onClick}
      {...props}
    >
      <MdDownload size={20} />
      {formatMessage({ id: textId })}
    </button>
  );
};

export default ExportButton;
